import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

let ReRunTid;
let ReRunTvalue;

const fetchReRunParallel = async () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateTestSuiteRerunInParallel&companyid=${user.companyid}&tsuid=${ReRunTid}&value=${ReRunTvalue}`,
  );

  return response.data;
};

const useUpdateReRunParallel = () => {
  const query = useQuery({
    queryKey: ["updateReRunParallel"],
    queryFn: () => {
      return fetchReRunParallel(ReRunTid, ReRunTvalue);
    },
    enabled: false,
    retry: true,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });

  const refetchWithParams = (id, value) => {
    ReRunTvalue = value;
    ReRunTid = id;
    query.refetch();
  };

  return {
    ...query,
    refetchWithParams,
  };
};

export default useUpdateReRunParallel;
